import { DBCommercialProposal } from '@Commercial/Proposal/Data/DataSource/API/Entity/Proposal'
import { CommercialProposalRepository } from '../../Data/Repository/ProposalRepository'

export interface DuplicateProposal {
    execute(entity: string): Promise<DBCommercialProposal>
    getSource(): string
}

export class DuplicateProposalUseCase implements DuplicateProposal {
    constructor(private repository: CommercialProposalRepository) {}
    async execute(entity: string): Promise<DBCommercialProposal> {
        return this.repository.duplicate(entity)
    }
    getSource(): string {
        return this.repository.dataSource.getSource()
    }
}
